import React, { useState, useMemo } from "react"
import DynamicDashboard from "../Dashboarding.components/DynamicDashboard"
import useGeneralViewPage from "../Dashboarding.logic/useGeneralViewPage"
import DB_TO_DASHBOARD_MAPPING from "../Dashboarding.constants/DB_TO_DASHBOARD_MAPPING"
import EmptyState from "../Dashboarding.components/EmptyState"
import "./GeneralView.css"

const FILTER_FIELDS = ["currency", "typeFlux", "buyerN1", "buyerEntityN2"]
const HIERARCHY_FIELDS = ["country", "buyerEntity", "deliveryEntity", "productName"]

// Nouveaux constantes pour les filtres de période
const PERIOD_TYPES = ["YEAR", "12M ROLLING"]
const MONTH_OPTIONS = [
  { value: "JAN", label: "January" },
  { value: "FEB", label: "February" },
  { value: "MAR", label: "March" },
  { value: "APR", label: "April" },
  { value: "MAY", label: "May" },
  { value: "JUN", label: "June" },
  { value: "JUL", label: "July" },
  { value: "AUG", label: "August" },
  { value: "SEP", label: "September" },
  { value: "OCT", label: "October" },
  { value: "NOV", label: "November" },
  { value: "DEC", label: "December" },
]

const GeneralView = () => {
  // États pour les nouveaux filtres de période
  const [selectedPeriodType, setSelectedPeriodType] = useState("YEAR")
  const [selectedMonth, setSelectedMonth] = useState("JAN")

  const periodFilters = {
    periodType: selectedPeriodType,
    month: selectedMonth,
  }
  const { data, isLoading, periods } = useGeneralViewPage(periodFilters)
  const [filters, setFilters] = useState({})
  
  // Calculer les années/périodes à afficher selon le mode
  const displayYears = useMemo(() => {
    if (selectedPeriodType === "12M ROLLING" && periods) {
      return periods.map(p => p.yearKey)
    }
    return DB_TO_DASHBOARD_MAPPING.years
  }, [selectedPeriodType, periods])

  // Drill depuis l'arbre (toggle le filtre correspondant)
  const handleDrill = (field, value) => {
    if (!FILTER_FIELDS.includes(field)) return
    setFilters(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [value]: !prev[field]?.[value],
      },
    }))
  }

  // Filtrer les données
  const filteredData = useMemo(() => {
    return data.filter(item => {
      return FILTER_FIELDS.every(field => {
        const activeFilters = Object.entries(filters[field] || {})
          .filter(([, active]) => active)
          .map(([value]) => value)
        return activeFilters.length === 0 || activeFilters.includes(item[field])
      })
    })
  }, [data, filters])

  if (isLoading) return <div>Chargement...</div>

  if (!isLoading && (!data || data.length === 0)) {
    return (
      <EmptyState
        title="No data available"
        description="No general view data found. Try adjusting your filters or check back later."
        icon="📊"
      />
    )
  }

  return (
    <div className="generalview-root">
      {/* Filtres de période */}
      <div className="generalview-filters">
        <div className="generalview-filter-group">
          <span className="generalview-filter-label">Period Type:</span>
          {PERIOD_TYPES.map((type) => (
            <button
              key={type}
              type="button"
              className={`generalview-filter-btn ${selectedPeriodType === type ? 'active' : ''}`}
              onClick={() => setSelectedPeriodType(type)}
            >
              {type}
            </button>
          ))}
        </div>

        {selectedPeriodType === "12M ROLLING" && (
          <div className="generalview-filter-group">
            <span className="generalview-filter-label">Starting Month:</span>
            <select
              className="generalview-filter-select"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {MONTH_OPTIONS.map((month) => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="generalview-card">
        {/* <div className="generalview-card-header generalview-card-header-gradient">
          <span className="generalview-card-icon">📊</span>
          <h2 className="generalview-card-title accent-title">
            Montant des ventes par Country &gt; Buyer entity &gt; Delivery entity &gt; Product
          </h2>
        </div> */}
        <div className="generalview-card-content">
          <DynamicDashboard
            data={filteredData}
            filterFields={FILTER_FIELDS}
            hierarchyFields={HIERARCHY_FIELDS}
            valueField="total"
            yearField={selectedPeriodType === "12M ROLLING" ? "period" : "year"}
            years={displayYears}
            title=""
            onDrill={handleDrill}
          />
        </div>
      </div>
    </div>
  )
}

export default GeneralView
